'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotBubblesIcon = function PlotBubblesIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M0 0h1.625v32H0zm32 30.375V32H0v-1.625zM9.625 19.188c0 .875-.75 1.625-1.625 1.625s-1.625-.75-1.625-1.625.75-1.563 1.625-1.563 1.625.688 1.625 1.563zM30.375 4a2.374 2.374 0 1 1-4.75 0 2.374 2.374 0 1 1 4.75 0zm-1.562 7.188a3.202 3.202 0 0 1-3.188 3.188c-1.813 0-3.25-1.438-3.25-3.188S23.813 8 25.625 8a3.202 3.202 0 0 1 3.188 3.188zm-6.438-5.563c0 2.188-1.75 4-4 4-2.188 0-4-1.813-4-4 0-2.25 1.813-4 4-4 2.25 0 4 1.75 4 4zM20.75 16c0 2.625-2.188 4.813-4.813 4.813-2.688 0-4.813-2.188-4.813-4.813s2.125-4.813 4.813-4.813c2.625 0 4.813 2.188 4.813 4.813zM9.5 12.813c0 1.75-1.438 3.188-3.188 3.188s-3.188-1.438-3.188-3.188c0-1.75 1.438-3.188 3.188-3.188S9.5 11.063 9.5 12.813zm.125 12c0 1.313-1.125 2.375-2.438 2.375s-2.375-1.063-2.375-2.375c0-1.313 1.063-2.438 2.375-2.438s2.438 1.125 2.438 2.438zM16 24c0 .875-.688 1.625-1.625 1.625-.875 0-1.563-.75-1.563-1.625s.688-1.625 1.563-1.625c.938 0 1.625.75 1.625 1.625zm11.188-5.625c0 1.375-1.063 2.438-2.375 2.438s-2.438-1.063-2.438-2.438c0-1.313 1.125-2.375 2.438-2.375s2.375 1.063 2.375 2.375zm-6.375 4.813c0 .438-.375.813-.813.813s-.813-.375-.813-.813c0-.438.375-.813.813-.813s.813.375.813.813zm-8-16c0 .438-.375.813-.813.813s-.813-.375-.813-.813c0-.438.375-.813.813-.813s.813.375.813.813z' })
    );
};

exports.default = PlotBubblesIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotBubblesIcon.js
// module id = 650
// module chunks = 0